import { render, staticRenderFns } from "./AddNewProducer.vue?vue&type=template&id=fa3fa2f0&scoped=true"
import script from "./AddNewProducer.vue?vue&type=script&lang=js"
export * from "./AddNewProducer.vue?vue&type=script&lang=js"
import style0 from "./AddNewProducer.vue?vue&type=style&index=0&id=fa3fa2f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3fa2f0",
  null
  
)

export default component.exports